module.exports = __webpack_public_path__ + "img/mail.b09ea645.svg";